const UBPE_FAQS = [
  {
    ask: 'panel.landing_ZD.faqs.faq.ask_1',
    answer: [
      { type: 'text', key: 'panel.landing_ZD.faqs.faq.answer_1' },
      { type: 'bold', key: 'panel.landing_ZD.faqs.faq.answer_1.2' },
      { type: 'text', key: 'panel.landing_ZD.faqs.faq.answer_1.3' },
      { type: 'bold', key: 'panel.landing_ZD.faqs.faq.answer_1.4' },
      { type: 'line-break', key: 'panel.landing_ZD.faqs.faq.answer_1.5' }
    ]
  },
  {
    ask: 'panel.landing_ZD.faqs.faq.ask_2',
    answer: [{ type: 'text', key: 'panel.landing_ZD.faqs.faq.answer_2' }]
  },
  {
    ask: 'panel.landing_ZD.faqs.faq.ask_3',
    answer: [{ type: 'text', key: 'panel.landing_ZD.faqs.faq.answer_3' }]
  },
  {
    ask: 'panel.landing_ZD.faqs.faq.ask_4',
    answer: [{ type: 'text', key: 'panel.landing_ZD.faqs.faq.answer_4' }]
  },
  {
    ask: 'panel.landing_ZD.faqs.faq.ask_5',
    answer: [{ type: 'text', key: 'panel.landing_ZD.faqs.faq.answer_5' }]
  }
];

export { UBPE_FAQS };
